unit DashboardPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseSitePage,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.ExtCtrls,
  DB,
  WEBLib.Grids,
  App.Enumerations,
  WEBLib.WebCtrls,
  CRM.Enumerations;


type
  TDashboardForm = class(TBaseSiteForm)
    DashboardDataTimer: TTimer;
    SchoolStatusTable: TTableControl;
    SchoolKindCountTable: TTableControl;
    OptionsFromDate: TDateTimePicker;
    OptionsToDate: TDateTimePicker;
    MissingEmailCountTable: TTableControl;
    PaymentsTable: TTableControl;
    BACSTable: TTableControl;
    ChequeTable: TTableControl;
    procedure DashboardDataTimerTimer(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure WebFormUnload(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormShow(Sender: TObject);
    procedure RefreshSchoolPaymentOptionsDate(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }

    [async]
    procedure GetData; async;

    procedure UpdateScreen;

  public
    { Public declarations }

    procedure RefreshChart;

  protected procedure LoadDFMValues; override; end;

var
  DashboardForm: TDashboardForm;

implementation

uses
  XData.Web.Client,
  MainDataModule,
  Rtti,
  Web.Dashboard.Utils,
  DashboardMethods;

{$R *.dfm}

procedure TDashboardForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  inherited;

  dashboardMethod.AllowProcessing := False;

end;

procedure TDashboardForm.WebFormCreate(Sender: TObject);
begin
  inherited;

  dashboardMethod := TDashboardMethods.Create;

end;

procedure TDashboardForm.WebFormDestroy(Sender: TObject);
begin
  dashboardMethod.AllowProcessing := False;

  inherited;

end;

procedure TDashboardForm.WebFormShow(Sender: TObject);
begin
  inherited;

  dashboardMethod.AllowProcessing := True;

  OptionsFromDate.Date := EncodeDate(CurrentYear, 1, 1);
  OptionsToDate.Date := EncodeDate(CurrentYear, 12, 31);

  RefreshSchoolPaymentOptionsDate(nil);

end;

procedure TDashboardForm.WebFormUnload(Sender: TObject);
begin
  dashboardMethod.AllowProcessing := False;

  inherited;

end;

procedure TDashboardForm.RefreshSchoolPaymentOptionsDate(Sender: TObject);
var
  dtOption: TDateTime;

begin
  inherited;

  // turn off the timer and trap date updating errors
  DashboardDataTimer.Enabled := False;
  dashboardMethod.AllowProcessing := False;

  try
    dtOption := dashboardMethod.FromDate;
    dashboardMethod.FromDate := OptionsFromDate.DateTime;

  except
    dashboardMethod.FromDate := dtOption;

  end;

  try
    dtOption := dashboardMethod.ToDate;
    dashboardMethod.ToDate := OptionsToDate.DateTime;

  except
    dashboardMethod.ToDate := dtOption;

  end;

  DashboardDataTimer.Enabled := True;

end;

procedure TDashboardForm.DashboardDataTimerTimer(Sender: TObject);
begin
  inherited;

  TTimer(Sender).Enabled := False;

  if dashboardMethod.AllowProcessing then
  begin
    // get data
    GetData;

    // update screen
    UpdateScreen;

  end;
  dashboardMethod.AllowProcessing := True;

  TTimer(Sender).Enabled := True;

end;

procedure TDashboardForm.RefreshChart;
var
  sJSON: string;
  oStatus: TSchoolStatus;

begin
  sJSON := '';
  for oStatus := TSchoolStatus.New to TSchoolStatus.GoneAway do
  begin
    if sJSON <> '' then
      sJSON := sJSON + ',';

    sJSON := sJSON +
      '{' +
        '"Status": "' + TRttiEnumerationType.GetName<TSchoolStatus>(oStatus) + '", ' +
        '"Value": "' + IntToStr(dashboardMethod.SchoolStatusData[oStatus]) + '"' +
      '}';

  end;

  sJSON := '[' + sJSON + ']';

end;

procedure TDashboardForm.GetData;
begin
  dashboardMethod.RefreshData_SchoolStatus;
  dashboardMethod.RefreshData_SchoolKind;
  dashboardMethod.RefreshData_SchoolKindPupilCount;
  dashboardMethod.RefreshData_MissingEmailCount;

  dashboardMethod.RefreshData_PaymentTable;

  dashboardMethod.RefreshData_BACSTable;
  dashboardMethod.RefreshData_ChequeTable;

end;

procedure TDashboardForm.UpdateScreen;
var
  oSchoolStatus: TSchoolStatus;
  oSchoolKind: TSchoolKind;
  oMissingEmail: TMissingEmailType;

begin
  // update school status table
  dashboardMethod.UpdateTableRow(SchoolStatusTable, 1, ['Total School Count', IntToStr(dashboardMethod.PaymentTableData.TotalSchoolCount)]);
  for oSchoolStatus := TSchoolStatus.New to TSchoolStatus.GoneAway do
    dashboardMethod.UpdateTableRow(
      SchoolStatusTable,
      Integer(oSchoolStatus) + 2,
      [School_Status[oSchoolStatus], IntToStr(dashboardMethod.SchoolStatusData[oSchoolStatus])]
    );

  // update school kind table
  dashboardMethod.UpdateTableRow(SchoolKindCountTable, 0, ['Kind', 'Count', 'Pupils']);
  for oSchoolKind := TSchoolKind.Primary to TSchoolKind.Independent do
  begin
    dashboardMethod.UpdateTableCell(
      SchoolKindCountTable,
      Integer(oSchoolKind) + 1,
      0,
      School_Kind[oSchoolKind]
    );

    dashboardMethod.UpdateTableCell(
      SchoolKindCountTable,
      Integer(oSchoolKind) + 1,
      1,
      IntToStr(dashboardMethod.SchoolKindData[oSchoolKind])
    );

    dashboardMethod.UpdateTableCell(
      SchoolKindCountTable,
      Integer(oSchoolKind) + 1,
      2,
      IntToStr(dashboardMethod.SchoolKindPupilCountData[oSchoolKind])
    );

  end;

  // missing email table
  for oMissingEmail := TMissingEmailType.ptAcademy to TMissingEmailType.ptSchool do
  begin
    dashboardMethod.UpdateTableRow(
      MissingEmailCountTable,
      Integer(oMissingEmail) + 1,
      [Missing_Email_Type[oMissingEmail], IntToStr(dashboardMethod.MissingEmailCountData[oMissingEmail])]
    );

  end;

  // payment table
  dashboardMethod.UpdateTableRow(PaymentsTable, 0, ['', '']);
  dashboardMethod.UpdateTableRow(PaymentsTable, 1, ['Total Payments', Format('£%m', [dashboardMethod.PaymentTableData.PaymentTotal])]);
  dashboardMethod.UpdateTableRow(PaymentsTable, 2, ['Payment Schools', IntToStr(dashboardMethod.PaymentTableData.PaymentSchoolCount)]);
  dashboardMethod.UpdateTableRow(PaymentsTable, 3, ['Total School Count', IntToStr(dashboardMethod.PaymentTableData.TotalSchoolCount)]);
  dashboardMethod.UpdatePercentage(PaymentsTable, 4, 'Sign-Up %', dashboardMethod.PaymentTableData.PaymentSchoolCount, dashboardMethod.PaymentTableData.TotalSchoolCount);
  dashboardMethod.UpdateAverage(PaymentsTable, 5, 'Average Payment', dashboardMethod.PaymentTableData.PaymentTotal, dashboardMethod.PaymentTableData.PaymentSchoolCount);
  dashboardMethod.UpdateTableRow(PaymentsTable, 6, ['Total Remittances', Format('£%m', [dashboardMethod.PaymentTableData.RemittanceTotal])]);
  dashboardMethod.UpdateTableRow(PaymentsTable, 7, ['Remittance Schools', IntToStr(dashboardMethod.PaymentTableData.RemittanceSchoolCount)]);

  // bacs table
  dashboardMethod.UpdateTableRow(BACSTable, 0, ['', '']);
  dashboardMethod.UpdateTableRow(BACSTable, 1, ['Total Value', Format('£%m', [dashboardMethod.BACSTableData.TotalPaymentValue])]);
  dashboardMethod.UpdateTableRow(BACSTable, 2, ['Total Payments', IntToStr(dashboardMethod.BACSTableData.TotalPaymentCount)]);
  dashboardMethod.UpdateTableRow(BACSTable, 3, ['Total School Count', IntToStr(dashboardMethod.BACSTableData.TotalSchoolCount)]);
  dashboardMethod.UpdatePercentage(BACSTable, 4, 'Primary %', dashboardMethod.BACSTableData.PrimaryCount, dashboardMethod.BACSTableData.TotalSchoolCount);
  dashboardMethod.UpdatePercentage(BACSTable, 5, 'Secondary %', dashboardMethod.BACSTableData.SecondaryCount, dashboardMethod.BACSTableData.TotalSchoolCount);
  dashboardMethod.UpdatePercentage(BACSTable, 6, 'Independent %', dashboardMethod.BACSTableData.IndependentCount, dashboardMethod.BACSTableData.TotalSchoolCount);

  // cheque table
  dashboardMethod.UpdateTableRow(ChequeTable, 0, ['', '']);
  dashboardMethod.UpdateTableRow(ChequeTable, 1, ['Total Value', Format('£%m', [dashboardMethod.ChequeTableData.TotalPaymentValue])]);
  dashboardMethod.UpdateTableRow(ChequeTable, 2, ['Total Payments', IntToStr(dashboardMethod.ChequeTableData.TotalPaymentCount)]);
  dashboardMethod.UpdateTableRow(ChequeTable, 3, ['Total School Count', IntToStr(dashboardMethod.ChequeTableData.TotalSchoolCount)]);
  dashboardMethod.UpdatePercentage(ChequeTable, 4, 'Primary %', dashboardMethod.ChequeTableData.PrimaryCount, dashboardMethod.ChequeTableData.TotalSchoolCount);
  dashboardMethod.UpdatePercentage(ChequeTable, 5, 'Secondary %', dashboardMethod.ChequeTableData.SecondaryCount, dashboardMethod.ChequeTableData.TotalSchoolCount);
  dashboardMethod.UpdatePercentage(ChequeTable, 6, 'Independent %', dashboardMethod.ChequeTableData.IndependentCount, dashboardMethod.ChequeTableData.TotalSchoolCount);

end;



procedure TDashboardForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  SchoolStatusTable := TTableControl.Create('school-status-table');
  SchoolKindCountTable := TTableControl.Create('school-kind-count-table');
  OptionsFromDate := TDateTimePicker.Create('payment-options-from-date');
  OptionsToDate := TDateTimePicker.Create('payment-options-to-date');
  MissingEmailCountTable := TTableControl.Create('missing-emails-count-table');
  PaymentsTable := TTableControl.Create('payments-table');
  BACSTable := TTableControl.Create('bacs-table');
  ChequeTable := TTableControl.Create('cheque-table');
  DashboardDataTimer := TTimer.Create(Self);

  InputQueryDlg.BeforeLoadDFMValues;
  SchoolStatusTable.BeforeLoadDFMValues;
  SchoolKindCountTable.BeforeLoadDFMValues;
  OptionsFromDate.BeforeLoadDFMValues;
  OptionsToDate.BeforeLoadDFMValues;
  MissingEmailCountTable.BeforeLoadDFMValues;
  PaymentsTable.BeforeLoadDFMValues;
  BACSTable.BeforeLoadDFMValues;
  ChequeTable.BeforeLoadDFMValues;
  DashboardDataTimer.BeforeLoadDFMValues;
  try
    Name := 'DashboardForm';
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    SetEvent(Self, 'OnUnload', 'WebFormUnload');
    InputQueryDlg.Left := 24;
    InputQueryDlg.Top := 16;
    SchoolStatusTable.SetParentComponent(Self);
    SchoolStatusTable.Name := 'SchoolStatusTable';
    SchoolStatusTable.Left := 72;
    SchoolStatusTable.Top := 133;
    SchoolStatusTable.Width := 121;
    SchoolStatusTable.Height := 50;
    SchoolStatusTable.HeightStyle := ssAuto;
    SchoolStatusTable.WidthStyle := ssAuto;
    SchoolStatusTable.BorderColor := clSilver;
    SchoolStatusTable.ChildOrder := 7;
    SchoolStatusTable.ElementFont := efCSS;
    SchoolStatusTable.ElementHeaderClassName := 'thead-light';
    SchoolStatusTable.ElementPosition := epIgnore;
    SchoolStatusTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    SchoolStatusTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    SchoolStatusTable.Footer.ButtonElementClassName := 'btn btn-light';
    SchoolStatusTable.Footer.DropDownElementClassName := 'form-control';
    SchoolStatusTable.Footer.InputElementClassName := 'form-control';
    SchoolStatusTable.Footer.LinkActiveElementClassName := 'link-primary';
    SchoolStatusTable.Footer.LinkElementClassName := 'link-secondary';
    SchoolStatusTable.Footer.ListElementClassName := 'pagination';
    SchoolStatusTable.Footer.ListItemElementClassName := 'page-item';
    SchoolStatusTable.Footer.ListLinkElementClassName := 'page-link';
    SchoolStatusTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    SchoolStatusTable.Header.ButtonElementClassName := 'btn btn-light';
    SchoolStatusTable.Header.DropDownElementClassName := 'form-control';
    SchoolStatusTable.Header.InputElementClassName := 'form-control';
    SchoolStatusTable.Header.LinkActiveElementClassName := 'link-primary';
    SchoolStatusTable.Header.LinkElementClassName := 'link-secondary';
    SchoolStatusTable.Header.ListElementClassName := 'pagination';
    SchoolStatusTable.Header.ListItemElementClassName := 'page-item';
    SchoolStatusTable.Header.ListLinkElementClassName := 'page-link';
    SchoolStatusTable.ColCount := 2;
    SchoolStatusTable.RowCount := 0;
    SchoolKindCountTable.SetParentComponent(Self);
    SchoolKindCountTable.Name := 'SchoolKindCountTable';
    SchoolKindCountTable.Left := 199;
    SchoolKindCountTable.Top := 133;
    SchoolKindCountTable.Width := 121;
    SchoolKindCountTable.Height := 50;
    SchoolKindCountTable.HeightStyle := ssAuto;
    SchoolKindCountTable.WidthStyle := ssAuto;
    SchoolKindCountTable.BorderColor := clSilver;
    SchoolKindCountTable.ChildOrder := 7;
    SchoolKindCountTable.ElementFont := efCSS;
    SchoolKindCountTable.ElementHeaderClassName := 'thead-light';
    SchoolKindCountTable.ElementPosition := epIgnore;
    SchoolKindCountTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    SchoolKindCountTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    SchoolKindCountTable.Footer.ButtonElementClassName := 'btn btn-light';
    SchoolKindCountTable.Footer.DropDownElementClassName := 'form-control';
    SchoolKindCountTable.Footer.InputElementClassName := 'form-control';
    SchoolKindCountTable.Footer.LinkActiveElementClassName := 'link-primary';
    SchoolKindCountTable.Footer.LinkElementClassName := 'link-secondary';
    SchoolKindCountTable.Footer.ListElementClassName := 'pagination';
    SchoolKindCountTable.Footer.ListItemElementClassName := 'page-item';
    SchoolKindCountTable.Footer.ListLinkElementClassName := 'page-link';
    SchoolKindCountTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    SchoolKindCountTable.Header.ButtonElementClassName := 'btn btn-light';
    SchoolKindCountTable.Header.DropDownElementClassName := 'form-control';
    SchoolKindCountTable.Header.InputElementClassName := 'form-control';
    SchoolKindCountTable.Header.LinkActiveElementClassName := 'link-primary';
    SchoolKindCountTable.Header.LinkElementClassName := 'link-secondary';
    SchoolKindCountTable.Header.ListElementClassName := 'pagination';
    SchoolKindCountTable.Header.ListItemElementClassName := 'page-item';
    SchoolKindCountTable.Header.ListLinkElementClassName := 'page-link';
    SchoolKindCountTable.ColCount := 3;
    SchoolKindCountTable.RowCount := 0;
    OptionsFromDate.SetParentComponent(Self);
    OptionsFromDate.Name := 'OptionsFromDate';
    OptionsFromDate.Left := 72;
    OptionsFromDate.Top := 77;
    OptionsFromDate.Width := 121;
    OptionsFromDate.Height := 22;
    OptionsFromDate.ElementClassName := 'form-control';
    OptionsFromDate.HeightStyle := ssAuto;
    OptionsFromDate.WidthStyle := ssAuto;
    OptionsFromDate.BorderStyle := bsSingle;
    OptionsFromDate.ChildOrder := 1;
    OptionsFromDate.Color := clWhite;
    OptionsFromDate.Date := 45642.000000000000000000;
    OptionsFromDate.ElementFont := efCSS;
    OptionsFromDate.ElementPosition := epIgnore;
    OptionsFromDate.Role := '';
    OptionsFromDate.Text := '';
    SetEvent(OptionsFromDate, Self, 'OnChange', 'RefreshSchoolPaymentOptionsDate');
    OptionsToDate.SetParentComponent(Self);
    OptionsToDate.Name := 'OptionsToDate';
    OptionsToDate.Left := 72;
    OptionsToDate.Top := 105;
    OptionsToDate.Width := 121;
    OptionsToDate.Height := 22;
    OptionsToDate.ElementClassName := 'form-control';
    OptionsToDate.HeightStyle := ssAuto;
    OptionsToDate.WidthStyle := ssAuto;
    OptionsToDate.BorderStyle := bsSingle;
    OptionsToDate.ChildOrder := 1;
    OptionsToDate.Color := clWhite;
    OptionsToDate.Date := 45642.000000000000000000;
    OptionsToDate.ElementFont := efCSS;
    OptionsToDate.ElementPosition := epIgnore;
    OptionsToDate.Role := '';
    OptionsToDate.Text := '';
    SetEvent(OptionsToDate, Self, 'OnChange', 'RefreshSchoolPaymentOptionsDate');
    MissingEmailCountTable.SetParentComponent(Self);
    MissingEmailCountTable.Name := 'MissingEmailCountTable';
    MissingEmailCountTable.Left := 326;
    MissingEmailCountTable.Top := 133;
    MissingEmailCountTable.Width := 121;
    MissingEmailCountTable.Height := 50;
    MissingEmailCountTable.HeightStyle := ssAuto;
    MissingEmailCountTable.WidthStyle := ssAuto;
    MissingEmailCountTable.BorderColor := clSilver;
    MissingEmailCountTable.ChildOrder := 7;
    MissingEmailCountTable.ElementFont := efCSS;
    MissingEmailCountTable.ElementHeaderClassName := 'thead-light';
    MissingEmailCountTable.ElementPosition := epIgnore;
    MissingEmailCountTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    MissingEmailCountTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    MissingEmailCountTable.Footer.ButtonElementClassName := 'btn btn-light';
    MissingEmailCountTable.Footer.DropDownElementClassName := 'form-control';
    MissingEmailCountTable.Footer.InputElementClassName := 'form-control';
    MissingEmailCountTable.Footer.LinkActiveElementClassName := 'link-primary';
    MissingEmailCountTable.Footer.LinkElementClassName := 'link-secondary';
    MissingEmailCountTable.Footer.ListElementClassName := 'pagination';
    MissingEmailCountTable.Footer.ListItemElementClassName := 'page-item';
    MissingEmailCountTable.Footer.ListLinkElementClassName := 'page-link';
    MissingEmailCountTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    MissingEmailCountTable.Header.ButtonElementClassName := 'btn btn-light';
    MissingEmailCountTable.Header.DropDownElementClassName := 'form-control';
    MissingEmailCountTable.Header.InputElementClassName := 'form-control';
    MissingEmailCountTable.Header.LinkActiveElementClassName := 'link-primary';
    MissingEmailCountTable.Header.LinkElementClassName := 'link-secondary';
    MissingEmailCountTable.Header.ListElementClassName := 'pagination';
    MissingEmailCountTable.Header.ListItemElementClassName := 'page-item';
    MissingEmailCountTable.Header.ListLinkElementClassName := 'page-link';
    MissingEmailCountTable.ColCount := 2;
    MissingEmailCountTable.RowCount := 0;
    PaymentsTable.SetParentComponent(Self);
    PaymentsTable.Name := 'PaymentsTable';
    PaymentsTable.Left := 199;
    PaymentsTable.Top := 77;
    PaymentsTable.Width := 121;
    PaymentsTable.Height := 50;
    PaymentsTable.HeightStyle := ssAuto;
    PaymentsTable.WidthStyle := ssAuto;
    PaymentsTable.BorderColor := clSilver;
    PaymentsTable.ChildOrder := 10;
    PaymentsTable.ElementFont := efCSS;
    PaymentsTable.ElementHeaderClassName := 'thead-light';
    PaymentsTable.ElementPosition := epIgnore;
    PaymentsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PaymentsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    PaymentsTable.Footer.ButtonElementClassName := 'btn btn-light';
    PaymentsTable.Footer.DropDownElementClassName := 'form-control';
    PaymentsTable.Footer.InputElementClassName := 'form-control';
    PaymentsTable.Footer.LinkActiveElementClassName := 'link-primary';
    PaymentsTable.Footer.LinkElementClassName := 'link-secondary';
    PaymentsTable.Footer.ListElementClassName := 'pagination';
    PaymentsTable.Footer.ListItemElementClassName := 'page-item';
    PaymentsTable.Footer.ListLinkElementClassName := 'page-link';
    PaymentsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    PaymentsTable.Header.ButtonElementClassName := 'btn btn-light';
    PaymentsTable.Header.DropDownElementClassName := 'form-control';
    PaymentsTable.Header.InputElementClassName := 'form-control';
    PaymentsTable.Header.LinkActiveElementClassName := 'link-primary';
    PaymentsTable.Header.LinkElementClassName := 'link-secondary';
    PaymentsTable.Header.ListElementClassName := 'pagination';
    PaymentsTable.Header.ListItemElementClassName := 'page-item';
    PaymentsTable.Header.ListLinkElementClassName := 'page-link';
    PaymentsTable.ColCount := 2;
    PaymentsTable.RowCount := 0;
    BACSTable.SetParentComponent(Self);
    BACSTable.Name := 'BACSTable';
    BACSTable.Left := 326;
    BACSTable.Top := 77;
    BACSTable.Width := 121;
    BACSTable.Height := 50;
    BACSTable.HeightStyle := ssAuto;
    BACSTable.WidthStyle := ssAuto;
    BACSTable.BorderColor := clSilver;
    BACSTable.ChildOrder := 11;
    BACSTable.ElementFont := efCSS;
    BACSTable.ElementHeaderClassName := 'thead-light';
    BACSTable.ElementPosition := epIgnore;
    BACSTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    BACSTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    BACSTable.Footer.ButtonElementClassName := 'btn btn-light';
    BACSTable.Footer.DropDownElementClassName := 'form-control';
    BACSTable.Footer.InputElementClassName := 'form-control';
    BACSTable.Footer.LinkActiveElementClassName := 'link-primary';
    BACSTable.Footer.LinkElementClassName := 'link-secondary';
    BACSTable.Footer.ListElementClassName := 'pagination';
    BACSTable.Footer.ListItemElementClassName := 'page-item';
    BACSTable.Footer.ListLinkElementClassName := 'page-link';
    BACSTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    BACSTable.Header.ButtonElementClassName := 'btn btn-light';
    BACSTable.Header.DropDownElementClassName := 'form-control';
    BACSTable.Header.InputElementClassName := 'form-control';
    BACSTable.Header.LinkActiveElementClassName := 'link-primary';
    BACSTable.Header.LinkElementClassName := 'link-secondary';
    BACSTable.Header.ListElementClassName := 'pagination';
    BACSTable.Header.ListItemElementClassName := 'page-item';
    BACSTable.Header.ListLinkElementClassName := 'page-link';
    BACSTable.ColCount := 2;
    BACSTable.RowCount := 0;
    ChequeTable.SetParentComponent(Self);
    ChequeTable.Name := 'ChequeTable';
    ChequeTable.Left := 453;
    ChequeTable.Top := 77;
    ChequeTable.Width := 121;
    ChequeTable.Height := 50;
    ChequeTable.HeightStyle := ssAuto;
    ChequeTable.WidthStyle := ssAuto;
    ChequeTable.BorderColor := clSilver;
    ChequeTable.ChildOrder := 11;
    ChequeTable.ElementFont := efCSS;
    ChequeTable.ElementHeaderClassName := 'thead-light';
    ChequeTable.ElementPosition := epIgnore;
    ChequeTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    ChequeTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    ChequeTable.Footer.ButtonElementClassName := 'btn btn-light';
    ChequeTable.Footer.DropDownElementClassName := 'form-control';
    ChequeTable.Footer.InputElementClassName := 'form-control';
    ChequeTable.Footer.LinkActiveElementClassName := 'link-primary';
    ChequeTable.Footer.LinkElementClassName := 'link-secondary';
    ChequeTable.Footer.ListElementClassName := 'pagination';
    ChequeTable.Footer.ListItemElementClassName := 'page-item';
    ChequeTable.Footer.ListLinkElementClassName := 'page-link';
    ChequeTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    ChequeTable.Header.ButtonElementClassName := 'btn btn-light';
    ChequeTable.Header.DropDownElementClassName := 'form-control';
    ChequeTable.Header.InputElementClassName := 'form-control';
    ChequeTable.Header.LinkActiveElementClassName := 'link-primary';
    ChequeTable.Header.LinkElementClassName := 'link-secondary';
    ChequeTable.Header.ListElementClassName := 'pagination';
    ChequeTable.Header.ListItemElementClassName := 'page-item';
    ChequeTable.Header.ListLinkElementClassName := 'page-link';
    ChequeTable.ColCount := 2;
    ChequeTable.RowCount := 0;
    DashboardDataTimer.SetParentComponent(Self);
    DashboardDataTimer.Name := 'DashboardDataTimer';
    SetEvent(DashboardDataTimer, Self, 'OnTimer', 'DashboardDataTimerTimer');
    DashboardDataTimer.Left := 80;
    DashboardDataTimer.Top := 16;
  finally
    InputQueryDlg.AfterLoadDFMValues;
    SchoolStatusTable.AfterLoadDFMValues;
    SchoolKindCountTable.AfterLoadDFMValues;
    OptionsFromDate.AfterLoadDFMValues;
    OptionsToDate.AfterLoadDFMValues;
    MissingEmailCountTable.AfterLoadDFMValues;
    PaymentsTable.AfterLoadDFMValues;
    BACSTable.AfterLoadDFMValues;
    ChequeTable.AfterLoadDFMValues;
    DashboardDataTimer.AfterLoadDFMValues;
  end;
end;

end.
